<div *ngIf="!simplified else simpleView" class="d-flex justify-content-between">
  <div [ngSwitch]="activity.type" class="activity-content">
    <activity-row-accepted-bank-statement-terms *ngSwitchCase="'acceptedBankStatementsTerms'"
                                                [activity]="activity"></activity-row-accepted-bank-statement-terms>
    <div *ngSwitchCase="'note'">
      <activity-row-note [activity]="activity"></activity-row-note>
    </div>
    <div *ngSwitchCase="'complaint'">
      <activity-row-note [activity]="activity" isComplaint="true"></activity-row-note>
    </div>
    <div *ngSwitchCase="'nextStep'">
      <activity-row-next-step [activity]="activity"></activity-row-next-step>
    </div>
    <div *ngSwitchCase="'reminder'">
      <activity-row-reminder [activity]="activity"></activity-row-reminder>
    </div>
    <div *ngSwitchCase="'reminder-fired'">
      <activity-row-reminder-fired [activity]="activity"></activity-row-reminder-fired>
    </div>
    <div *ngSwitchCase="'application'">
      <activity-row-application [activity]="activity"></activity-row-application>
    </div>
    <div *ngSwitchCase="'call'">
      <activity-row-call [activity]="activity"></activity-row-call>
    </div>
    <div *ngSwitchCase="'chat'">
      <activity-row-chat [activity]="activity" [borrower]="borrower"></activity-row-chat>
    </div>
    <div *ngSwitchCase="'cxInteraction'">
      <activity-row-cx-interaction [activity]="activity"></activity-row-cx-interaction>
    </div>
    <div *ngSwitchCase="'message'">
      <activity-row-message [activity]="activity"></activity-row-message>
    </div>
    <div *ngSwitchCase="'decisioningQualifierOverride'">
        <activity-row-decisioning-qualifier-override [activity]="activity"></activity-row-decisioning-qualifier-override>
    </div>
    <div *ngSwitchCase="'created'">
      <activity-row-created [activity]="activity"></activity-row-created>
    </div>
    <div *ngSwitchCase="'deal'">
      <activity-row-deal [activity]="activity"></activity-row-deal>
    </div>
    <div *ngSwitchCase="'deleted'">
      <activity-row-deleted [activity]="activity" [borrower]="borrower"></activity-row-deleted>
    </div>
    <div *ngSwitchCase="'bouncedMessage'">
      <activity-row-bounced-message [activity]="activity" [borrower]="borrower"></activity-row-bounced-message>
    </div>
    <div *ngSwitchCase="'assignment'">
      <activity-row-assignment [activity]="activity"></activity-row-assignment>
    </div>
    <div *ngSwitchCase="'sms'">
      <activity-row-sms [activity]="activity" [borrower]="borrower"></activity-row-sms>
    </div>
    <div *ngSwitchCase="'finicityRepull'">
      <activity-row-bank-aggregator [activity]="activity"></activity-row-bank-aggregator>
    </div>
    <div *ngSwitchCase="'signup'">
      <activity-row-signup [activity]="activity"></activity-row-signup>
    </div>
    <div *ngSwitchCase="'aktifyReengagement'">
      <activity-row-aktify-reengagement [activity]="activity"></activity-row-aktify-reengagement>
    </div>
    <div *ngSwitchCase="'pppOptIn'">
      <activity-row-ppp-opt-in [activity]="activity"></activity-row-ppp-opt-in>
    </div>
    <div *ngSwitchCase="'pppOptOut'">
      <activity-row-ppp-opt-out [activity]="activity"></activity-row-ppp-opt-out>
    </div>
    <div *ngSwitchCase="'ocrolusDocumentCategoryUpdated'">
      <activity-row-doc-category-updated [documentCategories]="documentCategories$ | async"
                                         [activity]="activity"></activity-row-doc-category-updated>
    </div>
    <div *ngSwitchCase="'ocrolusDocumentCategoryVerified'">
      <activity-row-doc-category-verified [documentCategories]="documentCategories$ | async"
                                          [activity]="activity"></activity-row-doc-category-verified>
    </div>
    <div *ngSwitchCase="'ocrolusDocumentRejected'">
      <activity-row-doc-rejected [activity]="activity"></activity-row-doc-rejected>
    </div>
    <div *ngSwitchCase="'ocrolusDocumentCategoryUnknown'">
      <activity-row-doc-category-unknown [activity]="activity"></activity-row-doc-category-unknown>
    </div>
    <div *ngSwitchCase="'bankConnection'">
      <activity-row-bank-connection [activity]="activity"></activity-row-bank-connection>
    </div>
    <div *ngSwitchCase="'documentReviewed'">
      <activity-row-deal-document-reviewed [activity]="activity"></activity-row-deal-document-reviewed>
    </div>
    <div *ngSwitchCase="'documentRejectedForDeal'">
      <activity-row-deal-document-rejected [activity]="activity"></activity-row-deal-document-rejected>
    </div>
    <div *ngSwitchCase="'documentReviewClearedForDeal'">
      <activity-row-deal-document-cleared [activity]="activity"></activity-row-deal-document-cleared>
    </div>
    <div *ngSwitchCase="'documentAcceptedForDeal'">
      <activity-row-deal-document-accepted [activity]="activity"></activity-row-deal-document-accepted>
    </div>
    <div *ngSwitchCase="'documentRequirementOverride'">
      <activity-row-deal-document-requirement-override [activity]="activity"></activity-row-deal-document-requirement-override>
    </div>
    <div *ngSwitchDefault>
      <activity-row-default [activity]="activity"></activity-row-default>
    </div>
  </div>

  <div>
    <a href="javascript:" *ngIf="activity.type !== 'bankConnection'"
       [ngClass]="{'invisible': showComments || activity.comments.length}" (click)="showComments = true" class="pl-2">Comment</a>
  </div>

  <span class="date text-nowrap">{{ (activity.createdTimestamp * 1000) | date }} <span
    class="time">{{ (activity.createdTimestamp * 1000) | date:'shortTime' }}</span></span>

  <borrower-activity-comments *ngIf="showComments || activity.comments.length" [comments]="activity.comments"
                              [activity]="activity" (cancelAdd)="showComments = false"></borrower-activity-comments>

  <hr class="activity-divider"/>

</div>

<ng-template #simpleView>

  <div id="activity-{{activity.id}}" *ngIf="valid">
    <div class="tw-grid tw-grid-flow-col tw-justify-between tw-p-3">
      <div class="tw-grid tw-grid-flow-col tw-gap-4 tw-items-center">
        <mat-icon>{{icon}}</mat-icon>
        <h3 class="mb-0 !tw-font-bold">{{title}}</h3>
        <span>{{subTitle | truncate:40 }}</span>
        <span *ngIf="linkAction else simpleLink" interactive (click)="safeLinkAction()">{{linkText}}</span>
        <ng-template #simpleLink>
          <span *ngIf="link"><a interactive target="_blank" href="{{link}}">{{linkText}}</a></span>
        </ng-template>
      </div>

      <div class="tw-grid tw-grid-flow-col tw-gap-2 tw-items-center">
        <span>{{ (activity.createdTimestamp * 1000) | date:'shortTime' }}</span>
        <span> - </span>
        <span>{{ (activity.createdTimestamp * 1000) | date }}</span>
      </div>

    </div>

    <mat-divider></mat-divider>

  </div>

</ng-template>
